import { Controller } from "@hotwired/stimulus"

// This controller is used to update the screen with the number of selected leads.
export default class extends Controller {
  static get targets() {
    return ["selected", "selectedCount", "total"]
  }

  static get values() {
    return { selected: Number }
  }

  // This action updates the screen.
  // We trigger this using the check-all controller.
  update(event) {
    this.selectedValue = event.detail.checked

    if (this.selectedValue > 0) {
      this.selectedCountTarget.innerText = i18n.t("js.count_selected", { count: this.selectedValue })
      this.selectedTarget.classList.remove("d-none")
      if (this.hasTotalTarget) {
        this.totalTarget.classList.add("d-none")
      }
    } else {
      this.selectedTarget.classList.add("d-none")

      if (this.hasTotalTarget) {
        this.totalTarget.classList.remove("d-none")
      }
    }
  }
}
